module.exports = __webpack_public_path__ + "img/arrow-down.455b4b7a.svg";